module.exports = __webpack_public_path__ + "img/application8.983fdddb.png";